import { $t } from '@/utils';

import AnchorLinkMenu from '@/components/texteditor/advanced/components/AnchorLinkMenu';
import AudioButton from '@/components/texteditor/advanced/buttons/AudioButton';
import BlockquoteButton from '@/components/texteditor/advanced/buttons/BlockquoteButton';
import CodeButton from '@/components/texteditor/advanced/buttons/CodeButton';
import FacebookButton from '@/components/texteditor/advanced/buttons/FacebookButton';
import HTMLButton from '@/components/texteditor/advanced/buttons/HTMLButton';
import ImageButton from '@/components/texteditor/advanced/buttons/ImageButton';
import InstagramButton from '@/components/texteditor/advanced/buttons/InstagramButton';
import TikTokButton from '@/components/texteditor/advanced/buttons/TikTokButton';
import LinkButton from '@/components/texteditor/advanced/buttons/LinkButton';
import LiveButton from '@/components/texteditor/advanced/buttons/LiveButton';
import PhotogalleryButton from '@/components/texteditor/advanced/buttons/PhotogalleryButton';
import PollButton from '@/components/texteditor/advanced/buttons/PollButton';
import TextblockButton from '@/components/texteditor/advanced/buttons/TextblockButton';
import TwitterButton from '@/components/texteditor/advanced/buttons/TwitterButton';
import VideoButton from '@/components/texteditor/advanced/buttons/VideoButton';
import YoutubeButton from '@/components/texteditor/advanced/buttons/YoutubeButton';
import ScrollytellingSpacerButton from '@/components/texteditor/advanced/buttons/ScrollytellingSpacerButton';
import ScrollytellingImageButton from '@/components/texteditor/advanced/buttons/ScrollytellingImageButton';
import pick from 'lodash/pick';

export const availableSidebarButtons = {
  'ql-scrollytelling-image': {
    icon: 'add_a_photo',
    title: $t('message.editor.button.photo'),
    active: true,
    disabled: false,
    component: ScrollytellingImageButton,
  },
  'ql-scrollytelling-spacer': {
    icon: 'expand',
    title: $t('message.editor.button.scrollytellingSpacer'),
    active: true,
    disabled: false,
    component: ScrollytellingSpacerButton,
  },
  'ql-image': {
    icon: 'add_a_photo',
    title: $t('message.editor.button.photo'),
    active: true,
    disabled: false,
    component: ImageButton,
  },
  'ql-blockquote': {
    icon: 'format_quote',
    title: $t('message.editor.button.blockquote'),
    active: true,
    disabled: false,
    component: BlockquoteButton,
  },
  'ql-tweet': {
    icon: 'fa-twitter',
    title: $t('message.editor.button.twitter'),
    active: true,
    disabled: false,
    component: TwitterButton,
  },
  'ql-youtube': {
    icon: 'fa-youtube',
    title: $t('message.editor.button.youtube'),
    active: true,
    disabled: false,
    component: YoutubeButton,
  },
  'ql-code': {
    icon: 'code',
    title: $t('message.editor.button.code'),
    active: true,
    disabled: false,
    component: CodeButton,
  },
  'ql-textblock': {
    icon: 'text_format',
    title: $t('message.editor.button.textblock'),
    active: true,
    disabled: false,
    component: TextblockButton,
  },
  'ql-photogallery': {
    icon: 'photo_library',
    title: $t('message.editor.button.photogallery'),
    active: true,
    disabled: false,
    component: PhotogalleryButton,
  },
  'ql-video': {
    icon: 'videocam',
    title: $t('message.editor.button.video'),
    active: true,
    disabled: false,
    component: VideoButton,
  },
  'ql-audio': {
    icon: 'audiotrack',
    title: $t('message.editor.button.audio'),
    active: true,
    disabled: false,
    component: AudioButton,
  },
  'ql-instagram': {
    icon: 'fa-instagram',
    title: $t('message.editor.button.instagram'),
    active: true,
    disabled: false,
    component: InstagramButton,
  },
  'ql-tiktok': {
    icon: 'fa-tiktok',
    title: $t('message.editor.button.tiktok'),
    active: true,
    disabled: false,
    component: TikTokButton,
  },
  'ql-facebook': {
    icon: 'fa-facebook',
    title: $t('message.editor.button.facebook'),
    active: true,
    disabled: false,
    component: FacebookButton,
  },
  'ql-poll': {
    icon: 'poll',
    title: $t('message.editor.button.poll'),
    active: true,
    disabled: false,
    component: PollButton,
  },
  'ql-live': {
    icon: 'forum',
    title: $t('message.editor.button.live'),
    active: true,
    disabled: false,
    component: LiveButton,
  },
  'ql-html': {
    icon: 'web',
    title: $t('message.editor.button.html'),
    active: true,
    disabled: false,
    component: HTMLButton,
  },
};

const sidebar = {
  ...pick(availableSidebarButtons, [
    'ql-image',
    'ql-blockquote',
    'ql-tweet',
    'ql-youtube',
    'ql-code',
    'ql-textblock',
    'ql-photogallery',
    'ql-video',
    'ql-audio',
    'ql-instagram',
    'ql-tiktok',
    'ql-facebook',
    'ql-poll',
    'ql-live',
    'ql-html',
  ]),
};

const toolbar = {
  'ql-advanced-link': {
    icon: 'link',
    title: $t('message.editor.button.link'),
    active: true,
    disabled: false,
    component: LinkButton,
  },
  'ql-anchor-link': {
    icon: 'hashtag',
    title: $t('message.editor.button.anchor'),
    active: true,
    disabled: false,
    component: AnchorLinkMenu,
  },
};

export default {
  sidebar,
  toolbar,
};
